import styled from '@emotion/styled';

import { createClassNames } from '@hrworks/design-system/functions';

import { Button as _Button } from '../Button';

const Button = styled(_Button)(({ variant }) => ({
  justifyContent: 'center',
  width: '2.5em',
  height: '2.5em',
  padding: 0,
  '> *': {
    fontSize: variant === 'filled' || variant === 'ghost' ? '1.2em' : '1.429em',
  },
}));

const components = { Button };

export const S = {
  ...components,
  ...createClassNames('IconButton', components),
} as const;
